module.exports = __webpack_public_path__ + "src/assets/img/page9/7cb7619baf90fb8eadf6a94ddec8dff7.png";